export const isSpacedString = (s: string) => {
  return s.indexOf(" ") >= 0;
};
